import config from '../../config/config';
import { userRoleMapper } from '../UserManagement/Users/Users';
import { get } from 'lodash';

export const FEEDBACK_SUBMIT_SEND = 'SUPPORT/FEEDBACK_SUBMIT_SEND';
export const FEEDBACK_SUBMIT_SUCCESS = 'SUPPORT/FEEDBACK_SUBMIT_SUCCESS';
export const FEEDBACK_SUBMIT_FAILURE = 'SUPPORT/FEEDBACK_SUBMIT_FAILURE';
export const FEEDBACK_CLEAR = 'SUPPORT/FEEDBACK_CLEAR';

export function submitFeedback(feedback, self, merchants) {
    const role = self.role || userRoleMapper[get(self, 'accessRights.role')];
    const merchantString = merchants.map((merchant) => `${merchant.name} - ${merchant.merchantId}`).join(',\n\t');
    const fromString = `
Submitted by: ${self.firstName} ${self.lastName}
Email Address: ${self.userName}
User Role: ${role}
Merchant(s): ${merchantString}`;

    return {
        failureActionTypeOrCreator: submitFeedbackFailureActionCreator,
        fetchParams: {
            body: {
                message: `${feedback}
                ${fromString}`
            },
            method: 'POST',
            url: `${config.emailApiUrl}/feedback`
        },
        loadActionTypeOrCreator: FEEDBACK_SUBMIT_SEND,
        successActionTypeOrCreator: FEEDBACK_SUBMIT_SUCCESS
    };
}

export function submitFeedbackFailureActionCreator(error) {
    return {
        error,
        type: FEEDBACK_SUBMIT_FAILURE
    };
}

export function clearFeedback() {
    return { type: FEEDBACK_CLEAR };
}
